module.exports = __webpack_public_path__ + "img/Insightly.e983a34b.svg";